define("medius/core/registration", function () {
    "use strict";

    require("Core/Medius.Core.Web/Scripts/Orderbased/grid/objectDataSource");
    require("Core/Medius.Core.Web/Scripts/Medius/core/customTaskHandlers/abortImportHandler").register();
    require("Core/Medius.Core.Web/Scripts/Medius/models/userSettings/tabs/general").register();
    require("Core/Medius.Core.Web/Scripts/Medius/models/userSettings/tabs/dataSearchConfiguration").register();

    var ko = require("knockout"),
        $ = require("jquery"),
        AvailableTasksModal = require("Core/Medius.Core.Web/Scripts/components/availableTasksModal/availableTasksModal").getInstance;

    function register() {
        require("Core/Medius.Core.Web/Scripts/Medius/extensions/jquery/outerHtml");
        require("Core/Medius.Core.Web/Scripts/appInsights").initializeApplicationInsights();
        require("Core/Medius.Core.Web/Scripts/eventBus").start();

        require("Core/Medius.Core.Web/Scripts/lib/globalization").init();
        require("Core/Medius.Core.Web/Scripts/Medius/core/settingsProvider").init();
        require("Core/Medius.Core.Web/Scripts/Medius/core/authorizationKeys").init();
        require("Core/Medius.Core.Web/Scripts/Medius/core/type").preload();
        require("Core/Medius.Core.Web/Scripts/Medius/core/das").preload();

        require("Core/Medius.Core.Web/Scripts/Medius/components/components/bindings").register();
        require("Core/Medius.Core.Web/Scripts/Medius/components/presenters/bindings").register();
        require("Core/Medius.Core.Web/Scripts/Medius/components/editors/bindings");
        require("Core/Medius.Core.Web/Scripts/Medius/components/configurationProperties/configurationPropertyBinding");
        require("Core/Medius.Core.Web/Scripts/Medius/components/wizard/bindings/wizard").registerWizardBinding();
        require("Core/Medius.Core.Web/Scripts/Medius/components/generic/bindings").registerBidings();
        require("Core/Medius.Core.Web/Scripts/Medius/components/grid/bindings").registerGridBindings();
        require("Core/Medius.Core.Web/Scripts/Medius/components/validation/bindings").registerBindings();
        require("Core/Medius.Core.Web/Scripts/Medius/components/bindings/componentsContext").registerComponentsContextBinding();
        require("Core/Medius.Core.Web/Scripts/Medius/components/documentSearch/query/binding").registerEditDocumentSearchQueryBinding();

        require("Core/Medius.Core.Web/Scripts/Medius/apps/document/bindings/withModule").register();
        require("Core/Medius.Core.Web/Scripts/Medius/apps/document/models/HashFiles/withHashFilesModule").register();
        require("Core/Medius.Core.Web/Scripts/Medius/apps/administration/bindings/withEntityCtxModule").register();
        require("Core/Medius.Core.Web/Scripts/Medius/apps/administration/bindings/withBulkAdminModule").register();
        require("Core/Medius.Core.Web/Scripts/Medius/apps/administration/bindings/timepicker").register();


        require("medius/knockout/templateEngines/underscore");
        require("Core/Medius.Core.Web/Scripts/Models/userTask").register();
        require("Core/Medius.Core.Web/Scripts/Models/document").registerMapping();

        require("Core/Medius.Core.Web/Scripts/Medius/apps/administration/models/Medius.Core.Entities.Role/viewModelExtensions/roleDataObjectAutohorization").register();


        require("Core/Medius.Core.Web/Scripts/Medius/apps/documentSearch/framework").register();

        require("Core/Medius.Core.Web/Scripts/Medius/apps/administration/bindings/withEntityCtxTypeScriptModule").registerWithEntityCtxTypeScriptBinding();
        require("Core/Medius.Core.Web/Scripts/core/attachments/binding/attachments").register();

        require("Core/Medius.Core.Web/Scripts/Medius/kendo/bindings/kendoDialog").register();
        require("Core/Medius.Core.Web/Scripts/Medius/kendo/bindings/kendoGrid").register();
        require("Core/Medius.Core.Web/Scripts/Medius/kendo/bindings/kendoTreeView").register();
        require("Core/Medius.Core.Web/Scripts/Medius/kendo/bindings/kendoAutoComplete").register();
        require("Core/Medius.Core.Web/Scripts/Medius/kendo/bindings/kendoDropDownList").register();
        require("Core/Medius.Core.Web/Scripts/Medius/kendo/bindings/kendoMultiSelect");
        require("Core/Medius.Core.Web/Scripts/Medius/kendo/bindings/kendoListBox");
        require("Core/Medius.Core.Web/Scripts/Medius/kendo/bindings/kendoListView");
        require("Core/Medius.Core.Web/Scripts/Medius/kendo/bindings/kendoConnectedLists");

        require("Core/Medius.Core.Web/Scripts/components/mention/editor/bindings/cursorPosition");
        require("Core/Medius.Core.Web/Scripts/Medius/apps/workflow/studio/businessRuleEditor").register();
        require("Core/Medius.Core.Web/Scripts/components/pdfViewer/bindings/imageViewerContainer").register();
        require("Core/Medius.Core.Web/Scripts/Medius/components/editors/autocompleter/bindings/autoScroll").register();
        require("Core/Medius.Core.Web/Scripts/Models/amount").register();
        require("Core/Medius.Core.Web/Scripts/Medius/components/editors/autocompleter/currency/select-currency").register();
        require("Core/Medius.Core.Web/Scripts/Medius/core/labels/labelsRepository").init();

        require("core").init();

        $(document).ready(function () {
            require("Core/Medius.Core.Web/Scripts/components/topBar/topBarContainerViewModel").register();

            require("Core/Medius.Core.Web/Scripts/Medius/session/register").init();

            var availableTasksModal = AvailableTasksModal();
            ko.applyBindings(availableTasksModal, document.getElementById('available-tasks-modal'));
            ko.applyBindings(null, document.getElementById('report-context-menu-template'));

            //shortcuts modal registration
            require("Core/Medius.Core.Web/Scripts/components/shortcutsModal/shortcutsModal").register();
            require("Core/Medius.Core.Web/Scripts/Medius/passwordExpiringNotification").notifyAboutExpiringPassword();
        });
    }

    return { register: register };
});
